import { getContrastColor } from '@reflact/tsutil';

// getContrastColor() only understands hex colors; 'transparent' would otherwise yield an arbitrary black/white result.
export function getContrastColorSafe(color: string | undefined): string {
    if (!color || color === 'transparent') {
        return 'inherit';
    }
    return getContrastColor(color);
}
